<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterConfig"
      @filter-search-input="handleFilterSearchInput"
      @filter-value-change="handleFilterValueChange"
      :noResetCall="true"
    />

    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      :expandedItem="true"
      :expandWithApi="true"
      item-key="id"
      @expand-row="onExpandRow"
    >     
      <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:exportExcelParent="exportExcel"
        />
      </template>

      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <div class="tap-expanded-container">
            <div class="tap-title-card">
              <div class="tap-title">Transaction List</div>
              
              <v-progress-linear v-if="!expandedData[item.id]" indeterminate class="my-4"></v-progress-linear>
              
              <div v-if="expandedData[item.id] && expandedData[item.id].tap_data" class="tap-content-wrapper">
                <div class="tap-content">
                  <!-- TAP IN -->
                  <div v-if="expandedData[item.id].tap_data.tap_in" class="tap-section">
                    <v-card outlined class="tap-card">
                      <v-card-text class="pa-4">
                        <div class="primary--text mb-3 tap-section-title">TAP IN</div>
                        <div class="tap-row">
                          <span class="tap-label">Reff ID :</span>
                          <span class="tap-value">{{ expandedData[item.id].tap_data.tap_in.rrn || '-' }}</span>
                        </div>
                        <div class="tap-row">
                          <span class="tap-label">Time :</span>
                          <span class="tap-value">{{ expandedData[item.id].tap_data.tap_in.trx_datetime || '-' }}</span>
                        </div>
                        <div class="tap-row">
                          <span class="tap-label">Amount :</span>
                          <span class="tap-value">{{ expandedData[item.id].tap_data.tap_in.amount || '-' }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <!-- TAP OUT -->
                  <div v-if="expandedData[item.id].tap_data.tap_out" class="tap-section">
                    <v-card outlined class="tap-card">
                      <v-card-text class="pa-4">
                        <div class="error--text mb-3 tap-section-title">TAP OUT</div>
                        <div class="tap-row">
                          <span class="tap-label">Reff ID :</span>
                          <span class="tap-value">{{ expandedData[item.id].tap_data.tap_out.rrn || '-' }}</span>
                        </div>
                        <div class="tap-row">
                          <span class="tap-label">Time :</span>
                          <span class="tap-value">{{ expandedData[item.id].tap_data.tap_out.trx_datetime || '-' }}</span>
                        </div>
                        <div class="tap-row">
                          <span class="tap-label">Amount :</span>
                          <span class="tap-value">{{ expandedData[item.id].tap_data.tap_out.amount || '-' }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </template>

      <template v-slot:tooltip__qr_method="{ item }">
          <TooltipInformation
            :value="item.qr_method"
            :description="getTooltipMethod(item)"
          />
      </template>
      <template v-slot:tooltip__payment_type="{ item }">
        <TooltipInformation
          :value="item.payment_type"
          :description="getTooltipPayement(item)"
        />
      </template>
        <template slot="action" slot-scope="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-icon small class="mr-2" @click="viewItem(item.id)"> mdi-eye </v-icon>
        </td>
      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="500px">
      <NfcTransactionDetail :editedItem="editedItem" v-on:closeParent="close" />
    </v-dialog>
  </v-card>
</template>

<script>
import nfcTransactionMixin from '../../components/report/nfc-transaction/nfcTransactionMixin';


export default {
  mixins: [ nfcTransactionMixin ],
  components: {
    NfcTransactionDetail: () =>import('@components/report/nfc-transaction/NfcTransactionDetail.vue'),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TooltipInformation: () => import("../../components/@drontVue/components/TooltipInformation")
  },
};
</script>

<style scoped>
.tap-expanded-container {
  padding: 24px;
  background-color: #f5f5f5;
}

.tap-expanded-container {
  padding: 20px 0;
}

.tap-title-card {
  background-color: white;
  border-radius: 4px;
  padding: 16px;
  margin-left: 24px;
  margin-right: 24px;
}

.tap-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
}

.tap-content-wrapper {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 16px;
  max-width: 900px;
}

.tap-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  max-width: 900px;
}

.tap-section {
  flex: 1;
}

.tap-card {
  border: 1px solid #e0e0e0 !important;
}

.tap-section-title {
  font-weight: 600;
  font-size: 14px;
}

.tap-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.tap-label {
  color: #666;
  font-size: 13px;
  font-weight: 500;
}

.tap-value {
  color: #333;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}

@media (max-width: 960px) {
  .tap-content {
    grid-template-columns: 1fr;
  }
}
</style>